"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTracking = void 0;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var useTracking = function (trackingId) {
    if (trackingId === void 0) { trackingId = process.env.GA_MEASUREMENT_ID; }
    var location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(function () {
        if (!window.gtag)
            return;
        if (!trackingId) {
            console.log("Tracking not enabled, as `trackingId` was not given and there is no `GA_MEASUREMENT_ID`.");
            return;
        }
        window.gtag("config", trackingId, { page_path: location.pathname });
    }, [trackingId, location]);
};
exports.useTracking = useTracking;
